module.exports = __webpack_public_path__ + "media/images/logo_avatar-ec59040f9e2e0cafeaae6cd94ba75794.png";